import React from "react";
var __jsx = React.createElement;
import Markdown from "markdown-to-jsx";
import { useCart } from "@/common/Contexts/CartContext";
import { AuthPopupHOC, useSession } from "@/_MiniApps/auth/AuthContext";
import { trackEvents } from "@/common/events/events";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useCMS } from "@hooks/useCMS";
import { useTranslation } from "@i18n";
import banners from "@data/banners/login-pages/signup.json";
import useHelpers from "@hooks/useHelpers";
import useIsMobile from "@hooks/useIsMobile";
var PriceSkel = function PriceSkel(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  return /*#__PURE__*/React.createElement("span", {
    className: "inline-block bg-[#E9EEF5] rounded-md animate-pulse align-middle ".concat(className)
  });
};
var SummaryRow = function SummaryRow(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    _ref2$labelClass = _ref2.labelClass,
    labelClass = _ref2$labelClass === void 0 ? "" : _ref2$labelClass,
    _ref2$valueClass = _ref2.valueClass,
    valueClass = _ref2$valueClass === void 0 ? "" : _ref2$valueClass;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between py-2.5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-sm text-[#8A97AA] ".concat(labelClass)
  }, label), /*#__PURE__*/React.createElement("span", {
    className: "text-sm font-bold text-[#1B2035] ".concat(valueClass)
  }, value));
};
var OilCartSummary = function OilCartSummary(_ref3) {
  var _totalRow$content$off;
  var _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? "mobile" : _ref3$variant;
  var _useCart = useCart(),
    cartData = _useCart.cartData,
    cartId = _useCart.cartId,
    isLoading = _useCart.isLoading,
    items = _useCart.items,
    totalItems = _useCart.totalItems,
    totalFinalPrice = _useCart.totalFinalPrice;
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var lang = useLang();
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isMobile = useIsMobile();
  var summaryBlock = cartData === null || cartData === void 0 ? void 0 : cartData.find(function (b) {
    return b.component_type === "cart_summary";
  });
  var ctaBlock = cartData === null || cartData === void 0 ? void 0 : cartData.find(function (b) {
    return b.component_type === "cart_cta";
  });
  var authScreenDesign = {
    banners: {
      desktop: imageUrl(banners[lang].desktop_images[0]),
      mobile: imageUrl(banners[lang].mobile_images[0])
    },
    title: t("sign_register"),
    description: t("sign_register_access_account")
  };
  var handleCheckout = function handleCheckout(_userData, _isPendingActionCall) {
    if (!cartId) return;
    navigateToHard("/site/cart/checkout?cart_id=".concat(encodeURIComponent(cartId)));
  };
  var onCheckoutClick = function onCheckoutClick(checkAuth) {
    if (busy) return;
    var summary = {
      products_count: items.length,
      total_quantity: totalItems,
      total_amount: totalFinalPrice
    };
    if (__IS_CSR__) {
      localStorage.setItem("oil_cart_payment_summary", JSON.stringify(summary));
    }
    trackEvents("vas_checkout_started", summary);
    if (!isLoggedIn) {
      trackEvents("vas_checkout_login_required", {});
    }
    checkAuth(handleCheckout);
  };
  var busy = isLoading;
  if (!summaryBlock) return null;
  var priceRows = summaryBlock.content.filter(function (b) {
    return b.component_type === "cart_price_row";
  });
  var totalRow = summaryBlock.content.find(function (b) {
    return b.component_type === "cart_total_price_row";
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white md:rounded-2xl border border-solid border-[#E9EEF5] shadow-sm px-4 py-4"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-xl font-bold text-[#1B2035] m-0 pb-4 mb-3 border-solid  border-b border-[#E1E8F2]"
  }, summaryBlock.title), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, priceRows.map(function (row) {
    var isDiscount = row.content.current < 0;
    return /*#__PURE__*/React.createElement(SummaryRow, {
      key: row.id,
      label: row.title,
      labelClass: "!text-[#6B7EA5] !font-normal",
      valueClass: isDiscount ? "!text-[#00B362]" : "",
      value: busy ? /*#__PURE__*/React.createElement(PriceSkel, {
        className: "h-3.5 w-16"
      }) : /*#__PURE__*/React.createElement(Markdown, {
        className: "text-base"
      }, row.content.current_formatted)
    });
  })), totalRow && /*#__PURE__*/React.createElement("div", {
    className: "pt-2 mt-1 border-solid border-t border-[#E1E8F2]"
  }, /*#__PURE__*/React.createElement(SummaryRow, {
    label: totalRow.title,
    value: busy ? /*#__PURE__*/React.createElement(PriceSkel, {
      className: "h-5 w-24"
    }) : /*#__PURE__*/React.createElement(Markdown, {
      className: "text-xl"
    }, totalRow.content.current_formatted),
    labelClass: "!text-[#6B7EA5] !font-semibold !text-lg md:text-xl"
  }), !busy && ((_totalRow$content$off = totalRow.content.offer_badge) === null || _totalRow$content$off === void 0 ? void 0 : _totalRow$content$off.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex mt-1 mb-1 gap-2 flex-wrap"
  }, totalRow.content.offer_badge.map(function (badge, i) {
    return /*#__PURE__*/React.createElement("span", {
      key: i,
      className: "inline-flex items-center gap-1 text-sm rounded-full px-2 py-1 whitespace-nowrap",
      style: {
        color: badge.color,
        backgroundColor: badge.bg_color
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: badge.icon,
      className: "h-5 w-5 flex-shrink-0"
    }), badge.label);
  })))), variant === "desktop" && /*#__PURE__*/React.createElement(AuthPopupHOC, {
    authScreenDesign: authScreenDesign,
    customModalClassName: "modalHideHeader",
    renderFunc: function renderFunc(checkAuth) {
      var _ref4, _ctaBlock$content$pri;
      return /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          return onCheckoutClick(checkAuth);
        },
        disabled: busy,
        className: "mt-4 flex items-center justify-between w-full bg-[#0D0DB5] text-white font-bold rounded-xl px-4 py-3.5 cursor-pointer border-0 hover:bg-[#0b0b9a] transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center gap-2"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-base font-bold"
      }, ctaBlock === null || ctaBlock === void 0 ? void 0 : ctaBlock.content.cta_label)), busy ? /*#__PURE__*/React.createElement(PriceSkel, {
        className: "h-5 w-20 !bg-white/40"
      }) : /*#__PURE__*/React.createElement(Markdown, {
        className: "text-lg font-bold text-white"
      }, (_ref4 = (_ctaBlock$content$pri = ctaBlock === null || ctaBlock === void 0 ? void 0 : ctaBlock.content.price.current_formatted) !== null && _ctaBlock$content$pri !== void 0 ? _ctaBlock$content$pri : totalRow === null || totalRow === void 0 ? void 0 : totalRow.content.current_formatted) !== null && _ref4 !== void 0 ? _ref4 : ""));
    }
  }));
};
export default OilCartSummary;